module.exports = __webpack_public_path__ + "img/doc.c9359f46.png";